import style from './menu.module.scss';
import React, {useState} from "react";
import Slider from "react-slick";
import {Bar} from 'react-chartjs-2';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Scrollbars} from 'react-custom-scrollbars-2';
import {arrowRight, iconsSmile} from "../../util/assets";

function LeftArrow({onClick}) {
    return (
        <div className={style.leftArrow} onClick={onClick}>
            <img src={arrowRight}/>
        </div>
    )
}

function RightArrow({onClick}) {
    return (
        <div className={style.rightArrow} onClick={onClick}>
            <img src={arrowRight} alt=""/>
        </div>
    )
}
function SliderForMenu({iaqi, aqi}) {

    const items = () => {
        let sens = Object.keys(iaqi);
        return sens.reduce((acc, i) => {
            if(["o3", "pm10", "no2", "so2", "co"].indexOf(i) !== -1) {
                acc.push(i);
            }
            return acc;
        }, []);
    }

    const [desccriptionSlider, setDesccriptionSlider] = useState();

    const setDescSensor = (d) => {
        switch (d) {
            case "o3":
                setDesccriptionSlider(<><b>Ozone</b> is a highly reactive gas that can damage mucous and respiratory tissues in animals, and also tissues in plants, and above concentrations of about 0.1 ppm. While this makes ozone a potent respiratory hazard and pollutant near ground level</>);
                break;
            case "pm10":
                setDesccriptionSlider(<><b>Microscopic particles</b> of solid or liquid matter suspended in the Air size 10 Microns. Particulates are the most harmful form of air pollution due to their ability to penetrate deep into the lungs, blood streams and brain, causing health problems including heart attacks, respiratory disease, and premature death</>);
                break;
            case "no2":
                setDesccriptionSlider(<><b>Nitrogen dioxide</b> is a chemical compound with the formula NO. It is one of several nitrogen oxides. At higher temperatures it is a reddish-brown gas. It can be fatal if inhaled in large quantity</>);
                break;
            case "so2":
                setDesccriptionSlider(<><b>Sulfur dioxide.</b> is a chemical compound with the formula SO. It is one of several Sulfur oxides. At higher temperatures it is a reddish-brown gas. It can be fatal if inhaled in large quantity</>);
                break;
            case "co":
                setDesccriptionSlider(<><b>Carbon monoxide</b> is a colorless, odorless, tasteless, flammable gas that can be poisoning to human being</>);
                break;
            default:
                break;
        }
    }

    const statusAqi = (d, v) => {
        let status = 0;
        switch (d) {
            case "o3":
                // status = v > 374 ? 5 : v > 124 ? 4 : v > 104 ? 3 : v > 84 ? 2 : v > 64 ? 1 : 0;
                status = v > 300 ? 5 : v > 200 ? 4 : v > 150 ? 3 : v > 100 ? 2 : v > 50 ? 1 : 0;
                break;
            // case "pm25":
            //     status = v > 250 ? 5 : v > 150 ? 4 : v > 65 ? 3 : v > 40 ? 2 : v > 15 ? 1 : 0;
            //     break;
            case "pm10":
                status = v > 424 ? 5 : v > 354 ? 4 : v > 254 ? 3 : v > 154 ? 2 : v > 54 ? 1 : 0;
                break;
            // case "uvi":
            //     status = v > 10 ? 4 : v > 7 ? 3 : v > 5 ? 2 : v > 2 ? 1 : 0;
            //     break;

            case "no2":
                status =v > 400 ? 5 : v > 280 ? 4 : v > 180 ? 3 : v > 80 ? 2 : v > 40 ? 1 : 0;
                break;
            case "so2":
                status = v > 1600 ? 5 : v > 801 ? 4 : v > 380 ? 3 : v > 80 ? 2 : v > 40 ? 1 : 0;
                break;
            case "co":
                status = v > 34 ? 5 : v > 17 ? 4 : v > 10 ? 3 : v > 2 ? 2 : v > 1 ? 1 : 0;
                break;
            default:
                break;
        }
        return status;
    }
    const settings =
        {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            nextArrow: <RightArrow/>,
            prevArrow: <LeftArrow/>
        };

    return (
        <div className={style.sliderRow}>
            <Slider {...settings}>
                {items().map((i, index) => (
                    <div
                        className={style.itemSliderRow}
                        key={`slide_${index}`}
                        onMouseEnter={()=>setDescSensor(i)}
                        onMouseLeave={()=>setDesccriptionSlider("")}
                    >
                        <div
                            className={[style.itemSlider, style[`status${statusAqi(i, iaqi[i].v)}`]].join(" ")}>
                            <div className={style.head}>{i}</div>
                            <div className={style.value}>{iaqi[i].v}</div>
                            {/*<div className={style.index}>ppb</div>*/}
                        </div>
                    </div>
                ))}
            </Slider>
            {desccriptionSlider && (
                <div className={style.descriptionSlider}>
                    {desccriptionSlider}
                </div>
            )}

        </div>
    );
}

export default SliderForMenu;